
import { NumberValueType } from "../../../../../components/finalForms/libs/data/formControlTypes";
import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/finalForms/libs/data/ValidationTypes";


const initState = {
    organizationWorkScheduleId: 0,
    organizationId: 0,
    workingDays: "",
    workingHoursPerDay: "",
}

export const OrganizationWorkScheduleData = {
    name: "Organization Work Schedule From",
    initialState: initState,

    section: [
        {
            sectionId: 'OrganizationWorkSchedule',
            title: "Organization  Work Schedule Section",
            row: {},
            style: {
                sectionStyle: "col-lg-42 col-md-12 mb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>,
            fields: [
                {
                    id: "workingDays",
                    label: "Working Days",
                    Field_Name: "working days",
                    fieldType: FormFieldTypes.NUMERIC,
                    dataField: "workingDays",
                    valueType: NumberValueType.INT,
                    fieldSetting: {
                        placeholder: "Please Enter Working Days",
                        allowSpace: false,
                        maxLength: 1
                    },
                    validation: [
                        { type: validationTypes.REQUIRE },
                        {
                            type: "custom",
                            message: "Working Days must be a single digit (0-7).",
                            validate: (value) => value.length === 1 && /^[0-7]$/.test(value)
                        }
                    ],
                    style: {
                        containerCss: "col-lg-6 col-xl-6 col-md-6",
                    },
                },

                {
                    id: "workingHoursPerDay",
                    label: "Working Hours Per Day",
                    Field_Name: "working hours per day",
                    fieldType: FormFieldTypes.NUMERIC,
                    dataField: "workingHoursPerDay",
                    valueType: NumberValueType.DECIMAL,
                    fieldSetting: {
                        placeholder: "Please Enter Working Hours Per Day",
                        allowSpace: false,
                        maxLength: 4
                    },
                    validation: [
                        { type: validationTypes.REQUIRE },
                        {
                            type: "custom",
                            message: "Working Hours Per Day must be between 1 and 15.",
                            validate: (value) => /^(1[0-5]|[1-9])(\.[0-9]+)?$/.test(value)
                        }
                    ],
                    style: {
                        containerCss: "col-lg-6 col-xl-6 col-md-6",
                    },
                }
            ]
        }
    ]

};

// formFields: [
//     {
//         id: "workingDays",
//         label: "Working Days",
//         Field_Name: "Working Days",
//         fieldType: FormFieldTypes.INPUT,
//         dataField: "workingDays",
//         fieldSetting: {
//             allowSpace: true,
//         },
//         validation: [{ type: validationTypes.REQUIRE }],
//         style: {
//             containerCss: "col-lg-6 col-xl-6 col-md-6",
//         },
//     },
//     {
//         id: "workingHoursPerDay",
//         label: "Working Hours Per Day",
//         Field_Name: "Working Hours Per Day",
//         fieldType: FormFieldTypes.NUMERIC,
//         dataField: "workingHoursPerDay",
//         fieldSetting: {
//             allowSpace: false,
//         },
//         validation: [{ type: validationTypes.REQUIRE }, { type: "number" }],
//         style: {
//             containerCss: "col-lg-6 col-xl-6 col-md-6",
//         },
//     },
// ],